import { IconButton, PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import { generateAutomationName } from "../../../../helpers/generateAutomationName";
import { MAX_TOOLTIP, CREATE_NEW, MAXIMUM_TEXT } from "../../text";

import * as SC from "./style";
import type { FooterSchema } from "./type";

export const Footer = ({ isMaxReached, currentSetsNumber, maximum, onClick }: FooterSchema) => (
    <SC.DropdownFooter
        data-automation={generateAutomationName("home", ["header", "activation", "dropdown", "footer"])}
        key={generateAutomationName("home", ["header", "activation", "dropdown", "footer"])}
    >
        <PlainTooltip
            enabled={isMaxReached}
            tooltipContent={translate(MAX_TOOLTIP)}
        >
            <div>
                <IconButton
                    isDisabled={isMaxReached}
                    onClick={onClick}
                    type="flat"
                    iconName="add"
                    iconSize="xs"
                >
                    {translate(CREATE_NEW)}
                </IconButton>
            </div>
        </PlainTooltip>
        <SC.MaximumTextWrapper
            data-automation={generateAutomationName("home", ["header", "activation", "dropdown", "maximum", "text"])}
        >
            {translate(MAXIMUM_TEXT, { current: currentSetsNumber, maximum })}
        </SC.MaximumTextWrapper>
    </SC.DropdownFooter>
);

Footer.displayName = "Footer";
